module.exports = __webpack_public_path__ + "ath_game_web/img/transaction_fee.c0f8d424.png";